import { ApiClient } from "rest-api-client"
import { DeviceLicense } from "./types"
import { LuxedoRPC } from "luxedo-rpc"

export class DeviceApi {
	baseUrl: string

	constructor(baseUrl: string) {
		this.baseUrl = baseUrl
	}

	get client(): ApiClient {
		const headers = new Headers()
		headers.append("X-Csrftoken", LuxedoRPC.getCsrfToken())
		headers.append("Content-Type", "application/json")
		return new ApiClient(`${this.baseUrl}/devices`, {
			headers,
			credentials: "include",
		})
	}

	async setDeviceLicense(id: number, license: DeviceLicense) {
		const res = await this.client.post(`/${id}/license`, {
			license_type: license,
		})
	}

	async getDeviceStatus(id: number): Promise<{
		license: DeviceLicense
		subscriptionId: string
		subscriptionStatus: string
		isOperational: boolean
	}> {
		const res = await this.client.get(`/${id}/license`)
		return {
			license: res.license_type,
			subscriptionId: res.subscription_id,
			subscriptionStatus: res.subscription_status,
			isOperational: res.device_operational,
		}
	}

	async linkDeviceToSubscription(id: number, subscriptionId: string) {
		const res = await this.client.post(`/${id}/subscription`, {
			subscription_id: subscriptionId,
		})
	}

	async getDeviceLicense(id: number): Promise<DeviceLicense> {
		const res = await this.client.get(`/${id}/license`)
		return res.license_type
	}
}
